module.exports = __webpack_public_path__ + "img/ellipse-login.0fccc103.svg";